import { __extends } from "tslib";
import { NodeMaterialBlock } from '../../nodeMaterialBlock';
import { NodeMaterialBlockConnectionPointTypes } from '../../Enums/nodeMaterialBlockConnectionPointTypes';
import { NodeMaterialBlockTargets } from '../../Enums/nodeMaterialBlockTargets';
import { _TypeStore } from '../../../../Misc/typeStore';
/**
 * Block used to test if the fragment shader is front facing
 */
var FrontFacingBlock = /** @class */ (function (_super) {
    __extends(FrontFacingBlock, _super);
    /**
     * Creates a new FrontFacingBlock
     * @param name defines the block name
     */
    function FrontFacingBlock(name) {
        var _this = _super.call(this, name, NodeMaterialBlockTargets.Fragment) || this;
        _this.registerOutput("output", NodeMaterialBlockConnectionPointTypes.Float, NodeMaterialBlockTargets.Fragment);
        return _this;
    }
    /**
     * Gets the current class name
     * @returns the class name
     */
    FrontFacingBlock.prototype.getClassName = function () {
        return "FrontFacingBlock";
    };
    Object.defineProperty(FrontFacingBlock.prototype, "output", {
        /**
         * Gets the output component
         */
        get: function () {
            return this._outputs[0];
        },
        enumerable: false,
        configurable: true
    });
    FrontFacingBlock.prototype._buildBlock = function (state) {
        _super.prototype._buildBlock.call(this, state);
        if (state.target === NodeMaterialBlockTargets.Vertex) {
            throw "FrontFacingBlock must only be used in a fragment shader";
        }
        var output = this._outputs[0];
        state.compilationString += this._declareOutput(output, state) + " = gl_FrontFacing ? 1.0 : 0.0;\r\n";
        return this;
    };
    return FrontFacingBlock;
}(NodeMaterialBlock));
export { FrontFacingBlock };
_TypeStore.RegisteredTypes["BABYLON.FrontFacingBlock"] = FrontFacingBlock;
//# sourceMappingURL=frontFacingBlock.js.map